import { html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import PimsterFeedWidget from './pimster-feed-widget';

type RenderParams = {
  embedSrc: PimsterFeedWidget['embedSrc'];
  iframeId: PimsterFeedWidget['iframeId'];
  height: PimsterFeedWidget['height'];
};

export const renderContent = ({ embedSrc, iframeId, height }: RenderParams) =>
  html`<iframe
    id="${iframeId}"
    class="iframe"
    allow="autoplay; clipboard-read; clipboard-write"
    title="${iframeId}"
    src="${embedSrc}"
    style=${styleMap({ height })}
  ></iframe>`;
